import { render, staticRenderFns } from "./UploadHrDocument.vue?vue&type=template&id=2693b2b0&"
import script from "./UploadHrDocument.vue?vue&type=script&lang=js&"
export * from "./UploadHrDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports